/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
//   import config from "../config/createDistCounter.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CREATE_DIST_COUNTER } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { useDistCenterId } from "../provider";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateDistCounterMethods extends IPluginMethodMap {
  createDistCounter(args: any): Promise<any>;
}

export class CreateDistCounterService implements IAgentPlugin {
  readonly methods: ICreateDistCounterMethods;

  constructor() {
    this.methods = {
      createDistCounter: this.createDistCounter.bind(this),
    };
  }

  async createDistCounter(args: any) {
    const { distCenterId } = useDistCenterId();
    log.blue(`createDistCounter server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // return {...config}
      if (client) {
        const res = await client.mutate({
          mutation: CREATE_DIST_COUNTER,
          variables: {
            data: {
              ...args?.payload,
              distCent: distCenterId,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.createCounter,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
      // return {
      //   isEmpty: true,
      // };
    }
  }
}
